module.exports = __webpack_public_path__ + "img/edit-profile.54915213.svg";